import { render, staticRenderFns } from "./LayoutBasic.vue?vue&type=template&id=3f42ec5f&scoped=true"
import script from "./LayoutBasic.vue?vue&type=script&lang=js"
export * from "./LayoutBasic.vue?vue&type=script&lang=js"
import style0 from "./LayoutBasic.vue?vue&type=style&index=0&id=3f42ec5f&prod&lang=less&scoped=true"
import style1 from "./LayoutBasic.vue?vue&type=style&index=1&id=3f42ec5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f42ec5f",
  null
  
)

export default component.exports